import {
    Button,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppLocale } from '../../../../i18n/localeUtils'
import { Archive, Check } from 'react-feather'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { IsinEntity } from '@finance-lab/utils/types'

type IsinMapTableComponent = React.FC<{
    unusedIsins: IsinEntity[]
    onArchive: (isinToArchive: IsinEntity) => Promise<void>
    selectedIsin: IsinEntity | null
    setSelectedIsin: (unusedIsin: IsinEntity | null) => void
}>

export const IsinMapTable: IsinMapTableComponent = ({ unusedIsins, onArchive, selectedIsin, setSelectedIsin }) => {
        const { language: locale } = useAppLocale()

    const onSelectIsin = (isin: IsinEntity) => {
        // select the isin
        setSelectedIsin(isin)
    }

    if (unusedIsins === null || unusedIsins === undefined) {
        return (
            <>
                <Skeleton variant='rectangular' height={24 * 4} sx={{ my: 6 }} />
                <Skeleton variant='rectangular' height={24 * 4} sx={{ my: 6 }} />
                <Skeleton variant='rectangular' height={24 * 4} sx={{ my: 6 }} />
                <Skeleton variant='rectangular' height={24 * 4} sx={{ my: 6 }} />
            </>
        )
    }
    if (unusedIsins.length === 0) {
        return <Typography variant='body1'>Inga ISIN hittades</Typography>
    }

    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {unusedIsins.map((unusedIsin) => (
                        <TableRow key={unusedIsin.isin}>
                            <TableCell
                                sx={{ backgroundColor: unusedIsin.isin === selectedIsin?.isin ? 'yellow' : null }}
                            >
                                <Stack spacing={2}>
                                    <Typography variant='caption'>
                                        {formatDateYYYYMMDD(unusedIsin.tradeFirstDate, { locale })} {unusedIsin.instrumentName}
                                    </Typography>
                                    <Typography>{unusedIsin.isin}</Typography>
                                </Stack>
                            </TableCell>
                            <TableCell>
                                <Stack spacing={2}>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        size='small'
                                        onClick={() => onSelectIsin(unusedIsin)}
                                        endIcon={<Check size={16} />}
                                    >
                                        Välj
                                    </Button>
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        size='small'
                                        onClick={() => void onArchive(unusedIsin)}
                                        endIcon={<Archive size={16} />}
                                    >
                                        Arkiv
                                    </Button>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
